
import {
  isLocalStorageEnabled,

  getDataFromLocalStorage,

  setDataToLocalStorage,
} from "app/local_storages/native_api_adapter"

const COOKIE_KEY = "App.Pages.Cities.OverseasProperties.Index.Data.PageVisitCount.value"


const getValue = () => {
  if (!isLocalStorageEnabled()) { return 0 }

  // String
  const value_from_cookie = getDataFromLocalStorage(COOKIE_KEY).data
  if (typeof value_from_cookie !== "string") { return 0 }

  const parsed_integer = parseInt(value_from_cookie, 10)
  if (isNaN(parsed_integer)) { return 0 }

  return parsed_integer
}

const incrementValue = () => {
  const new_value = getValue() + 1
  setDataToLocalStorage(COOKIE_KEY, new_value.toString())
}

export default {
  getValue,
  incrementValue,
}
